module.exports = __webpack_public_path__ + "img/temporaire.3ca37fc0.png";